function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { ANALYTICS_KEY } from '../../../constants.js';
import { BlockEmbeddedAsset } from '../components/BlockEmbeddedAsset.js';
import { BlockEmbeddedEntry } from '../components/BlockEmbeddedEntry.js';
import { Divider } from '../components/Divider.js';
import { Heading } from '../components/Heading.js';
import { InlineHyperLink } from '../components/InlineHyperLink.js';
import { List } from '../components/List.js';
import { ListItem } from '../components/ListItem.js';
import { Paragraph } from '../components/Paragraph.js';
import { Quote } from '../components/Quote.js';
import { Table } from '../components/Table.js';
import { overrideContentfulParagraphWrapping } from '../utils/overrideContentfulParagraphWrapping.js';
const composeRichTextComponents = ({
  customRenderOptions,
  customRenderMarks,
  hasOverrideContentfulParagraphWrapping
} = {}) => props => {
  const mappedToPropsRenderOptions = customRenderOptions && Object.keys(customRenderOptions).map(key => {
    const fn = customRenderOptions[key];
    return [key, fn && fn(_objectSpread({}, props))];
  }).reduce((acc, cur) => {
    return _objectSpread(_objectSpread({}, acc), {}, {
      [cur[0]]: cur[1]
    });
  }, {});
  return {
    renderMark: _objectSpread({}, customRenderMarks),
    renderNode: _objectSpread(_objectSpread({
      [BLOCKS.HEADING_1]: Heading(_objectSpread({
        as: 'h1'
      }, props)),
      [BLOCKS.HEADING_2]: Heading(_objectSpread({
        as: 'h2'
      }, props)),
      [BLOCKS.HEADING_3]: Heading(_objectSpread({
        as: 'h3'
      }, props)),
      [BLOCKS.HEADING_4]: Heading(_objectSpread({
        as: 'h4'
      }, props)),
      [BLOCKS.HEADING_5]: Heading(_objectSpread({
        as: 'h5'
      }, props)),
      [BLOCKS.HEADING_6]: Heading(_objectSpread({
        as: 'h6'
      }, props)),
      [BLOCKS.PARAGRAPH]: Paragraph(_objectSpread({}, props)),
      [BLOCKS.EMBEDDED_ASSET]: BlockEmbeddedAsset(_objectSpread({}, props)),
      [BLOCKS.EMBEDDED_ENTRY]: BlockEmbeddedEntry(_objectSpread(_objectSpread({}, props), {}, {
        additionalProps: _objectSpread(_objectSpread({}, props), {}, {
          isFullWidth: false
        })
      })),
      [BLOCKS.LIST_ITEM]: ListItem(_objectSpread({}, props)),
      [BLOCKS.UL_LIST]: List(_objectSpread({
        as: 'ul'
      }, props)),
      [BLOCKS.OL_LIST]: List(_objectSpread({
        as: 'ol'
      }, props)),
      [BLOCKS.QUOTE]: Quote(_objectSpread({}, props)),
      [BLOCKS.TABLE]: Table(),
      [BLOCKS.HR]: Divider(),
      [INLINES.HYPERLINK]: InlineHyperLink(_objectSpread({
        dataQa: ANALYTICS_KEY.SharedRichText
      }, props)),
      [INLINES.ASSET_HYPERLINK]: InlineHyperLink(_objectSpread({}, props))
    }, mappedToPropsRenderOptions), hasOverrideContentfulParagraphWrapping && overrideContentfulParagraphWrapping())
  };
};
export { composeRichTextComponents };
//# sourceMappingURL=composeRichTextComponents.js.map
